const servicesTokens = {
  IToastService: Symbol(),
  ILoadingIndicatorService: Symbol(),
}

export { servicesTokens as ServicesTokens }
